/* eslint-disable eqeqeq */
/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * SubitiseElement.web.js -
*/

import React from 'react';
import PropTypes from 'prop-types';
import './SubitisingScreen.web.css';
export default class SubitiseElement extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    // If the object image is defined use that
    if (this.props.object != null || this.props.object != undefined) {
      return (
        <div id="square">
          <img className="subitising_object" src={this.props.object} />
        </div>
      );
    }

    if (this.props.colour != 'clear') {
      return (
        <div id="square">
          <div id="circle" style={{ backgroundColor: this.props.colour }} />
        </div>
      );
    }

    return (
      <div id="square">
        <div id="empty" />
      </div>
    );

  }
}

SubitiseElement.propTypes = {
  props: PropTypes.object,
  colour: PropTypes.string,
  object: PropTypes.number,
};
